// extracted by mini-css-extract-plugin
export default {"content":"pla-z","title":"qla-z","subTitle":"rla-z","banner":"sla-z","productCardOverride":"tla-z"};